import { render, staticRenderFns } from "./NonAgentNovelListItem.vue?vue&type=template&id=4d2dd473&scoped=true"
import script from "./NonAgentNovelListItem.vue?vue&type=script&lang=ts"
export * from "./NonAgentNovelListItem.vue?vue&type=script&lang=ts"
import style0 from "./NonAgentNovelListItem.vue?vue&type=style&index=0&id=4d2dd473&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2dd473",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2dd473')) {
      api.createRecord('4d2dd473', component.options)
    } else {
      api.reload('4d2dd473', component.options)
    }
    module.hot.accept("./NonAgentNovelListItem.vue?vue&type=template&id=4d2dd473&scoped=true", function () {
      api.rerender('4d2dd473', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/NonAgentNovelListItem.vue"
export default component.exports